import styled from 'styled-components';

export const ErrorContainer = styled.div`
    background: ${({ theme }) => theme.colors.lightBlue};
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 1024px) {
        flex-direction: column-reverse;
    }
`;

export const ErrorMessage = styled.div`
    margin: 99px 125px 99px 177px;

    @media screen and (max-width: 1024px) {
        margin: 0 92px 60px 91px;
        text-align: center;
    }

    @media screen and (max-width: 500px) {
        margin: 0 44px 40px 44px;
    }
`;

export const ErrorIcon = styled.div`
    margin: 100px 178px 100px 0;

    img {
        width: 315px;
        height: 315px;
    }

    @media screen and (max-width: 1024px) {
        margin: 60px 272px 30px 271px;
        text-align: center;
        img {
            width: 225px;
            height: 225px;
        }
    }

    @media screen and (max-width: 500px) {
        margin: 40px 116px 20px 116px;
        text-align: center;
        img {
            width: 88px;
            height: 88px;
        }
    }
`;

export const ErrorContactWrapper = styled.div`
    display: flex;
    @media screen and (max-width: 500px) {
        display: block;
    }
`;

export const ErrorButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    button {
        margin-bottom: 40px;
    }
`;
